import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const NewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (${breakpoint.lgMin}) {
    padding: 0 16px;
  }

  .link-button {
    margin: auto;
    order: 4;
    text-transform: uppercase;
    font-family: ${font.graphikCond};
    
    @media (${breakpoint.mdMin}) {
      margin-top: 24px;
    }
  }

`;

export const ContentWrapper = styled.div<{ $articleCount: number }>`
  display: grid;
  gap: 40px;
  order: 2;

  &.person-card {
    text-align: center;

    @media (${breakpoint.mdMin}) {
      text-align: left;
    }
  }

  @media (${breakpoint.mdMin}) {
    grid-template-columns: ${({ $articleCount }) => ($articleCount === 6 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)')};
    gap: 40px;
    
  }
  @media (${breakpoint.lgMin}) {
    grid-template-columns: ${({ $articleCount }) => ($articleCount === 6 ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)')};
  }
`;

export const GridVideos = styled.div<{ $articleCount: number }>`
    display: grid;
    gap: ${({ $articleCount }) => ($articleCount === 6 ? '24px' : '32px')};

    @media (${breakpoint.mdMin}) {
      grid-template-columns: repeat(2, 1fr);
      gap: ${({ $articleCount }) => ($articleCount === 6 ? '40px' : '32px')};
    }

    @media (${breakpoint.lgMin}) {
      grid-template-columns: repeat(4, 1fr);
    }
`;
